var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{ref:"scrolltop",staticClass:"icon icon-secondary scrolltop-btn",class:{ 'scrolltop-btn--visible': _vm.visible },attrs:{"title":"Наверх","aria-label":"Наверх"},on:{"click":_vm.scrollTop}},[_c('icon-arrow')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }